import { render, staticRenderFns } from "./GuestsArrival.vue?vue&type=template&id=0bc1b5bd&"
import script from "./GuestsArrival.vue?vue&type=script&lang=js&"
export * from "./GuestsArrival.vue?vue&type=script&lang=js&"
import style0 from "./GuestsArrival.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GuestsArrival.vue"
export default component.exports